import { Action } from '@ngrx/store';

import { FilterState } from '../../types/state';
import { FilterActions, FilterActionTypes } from '../actions/filter.actions';

const emptyState: FilterState = {
    concepts: null,
    evaluate: null,
    published: null,
    processingList: null
};

export function filterReducer(state = emptyState, action: Action): FilterState {
    const specificAction: FilterActions = action as FilterActions;

    switch (specificAction.type) {
        case FilterActionTypes.SetConceptsFilter:
            return { ...state, concepts: specificAction.payload };
        case FilterActionTypes.SetEvaluateFilter:
            return { ...state, evaluate: specificAction.payload };
        case FilterActionTypes.SetPublishedFilter:
            return { ...state, published: specificAction.payload };
        case FilterActionTypes.SetProcessingListFilter:
            return { ...state, processingList: specificAction.payload };
        case FilterActionTypes.UnsetFilters:
            return { ...emptyState };
        default:
            return state;
    }
}
